import * as React from "react";

import AboutUs from 'src/containers/5c-aboutUs/aboutUs';

export default () => {
  return <AboutUs />;
}